// extracted by mini-css-extract-plugin
export default {"btn":"PrintLink_btn__z1aTS"};